module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAAUVBMVEUAAAAbraz///8brawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrawbrayipQngAAAAGnRSTlMAAAABAwcIEB9WX4CIkKWmrLPAyNDe6e7v89c0bgkAAACQSURBVCjPtZHLEoIwDEWDUgqk8giFQv7/Q02KopWOG8ezyJ2exe1MAlAobag0qtAWFwGE6JGthmU8vLGC41qjZqdh1Ac+EdQzISKxk4nu8YgepbiZjfabuZF+fPk3Dp8h+un2wfS95+n7Pu+JfvcdEa2rjC7x19F7v20yxv/8qwxD3pdl6vUUCftdlvOaF4A7QEkSvfYoMKcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_icon_calendar_blue.png
// module id = 689
// module chunks = 0